import ManageTeams from '@components/manage.teams/manage.teams';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Main from '@components/layouts/main/main';
import Route from '@components/Route/Route';
// import AccountTabsLayouts from '@components/layouts/account.tabs.layout/account.tabs.layout';
import { createNewTeam } from '@redux/services/teams';
import { setCustomAlert, setModalOpen } from '@redux/actions/general';
import { setTeam, setUserAccounts } from '@redux/actions/user';
import dynamic from 'next/dynamic';
import { capturingPostHogEvent } from '@helpers/utils';

const AccountTabsLayouts = dynamic(
  () => import('@components/layouts/account.tabs.layout/account.tabs.layout'),
  {
    ssr: false,
  }
);
export default function Team() {
  const {
    user: { team, loggedUser: user, userAccounts },
    general: { dataFetchedFrom },
  } = useSelector((gState) => gState);
  const dispatch = useDispatch();
  const [localLoadingState, setLocalLoadingState] = useState(false);
  const [newTeamValue, setNewTeamValue] = useState(``);
  const [inviteSent, setInviteSent] = useState(false);
  const [teamMembers, setTeamMembers] = useState(null);
  const [teamOptionValue, setTeamOptionValue] = useState(null);
  const [modalType, setModalType] = useState('invite');

  useEffect(() => {
    setNewTeamValue(`${user?.name}'s Team`);
  }, [user?.name]);

  const [selectedTeam, setSelectedTeam] = useState(null);
  const [memberInfo, setMemberInfo] = useState(null);

  const handleModalOpen = (memId, memName, memRole) => {
    if (memId && memName) {
      setMemberInfo({ name: memName, id: memId, role: memRole });
    }
    dispatch(setModalOpen());
    if (inviteSent) {
      setInviteSent(false);
    }
  };
  const handleCreateNewTeam = () => {
    setLocalLoadingState(true);
    createNewTeam(newTeamValue).then(
      (res) => {
        const { data } = res.data;
        setNewTeamValue('');
        setLocalLoadingState(true);

        const tempData = teamMembers ? [...teamMembers] : [];
        tempData.push(data);
        setTeamMembers(tempData);
        const options = [
          ...(teamOptionValue || []),
          {
            label: data.title,
            id: data._id,
            owner: data.owner._id === user._id,
          },
        ];
        const userAccount = userAccounts?.find(
          (account) => account._id === data.owner._id
        );
        if (userAccount) {
          const list = userAccounts?.filter(
            (account) => account._id !== data.owner._id
          );
          const obj = {
            ...userAccount,
            accountType: 'personal-team',
            title: data?.title,
            owner: data?.owner,
            _id: data?._id,
          };
          console.log('debug', data);
          dispatch(setUserAccounts([obj, ...list]));
          dispatch(setTeam([obj, ...list]));
        }
        setTeamOptionValue(options);
        const teamOwner = options.find(({ owner }) => owner);
        if (teamOwner) {
          setSelectedTeam(teamOwner);
        } else {
          setSelectedTeam(options?.[0]);
        }
        setModalType('invite');
        handleModalOpen();
      },
      () => {
        setLocalLoadingState(false);
        dispatch(
          setCustomAlert({
            message: 'Could not create team',
            state: true,
            type: 'error',
          })
        );
        handleModalOpen();
      }
    );
    capturingPostHogEvent('Button: Create New Team');
  };

  const handleNewTeamModal = () => {
    setModalType('newteam');
    setTimeout(() => {
      handleModalOpen();
    }, 400);
  };
  return (
    <Main>
      <Route>
        <AccountTabsLayouts handleNewTeamModal={handleNewTeamModal}>
          <ManageTeams
            team={team}
            user={user}
            memberInfo={memberInfo}
            setMemberInfo={setMemberInfo}
            setTeamOptionValue={setTeamOptionValue}
            teamOptionValue={teamOptionValue}
            localLoadingState={localLoadingState}
            setLocalLoadingState={setLocalLoadingState}
            selectedTeam={selectedTeam}
            setSelectedTeam={setSelectedTeam}
            handleCreateNewTeam={handleCreateNewTeam}
            modalType={modalType}
            setModalType={setModalType}
            inviteSent={inviteSent}
            setInviteSent={setInviteSent}
            teamMembers={teamMembers}
            setTeamMembers={setTeamMembers}
            handleModalOpen={handleModalOpen}
            handleNewTeamModal={handleNewTeamModal}
            newTeamValue={newTeamValue}
            setNewTeamValue={setNewTeamValue}
            dataFetchedFrom={dataFetchedFrom}
          />
        </AccountTabsLayouts>
      </Route>
    </Main>
  );
}
